import React, { JSX } from 'react';
import { useScrollToTop } from '@ankr.com/raas-hooks';
import { Notifications, QueryLoadingAbsolute } from '@ankr.com/raas-ui';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { CssBaseline, ThemeProvider } from '@mui/material';

import '@ankr.com/assets/public/fonts/index.css';

import { useAuth } from '../../../auth/hooks/useAuth';
import { useLocaleInit } from '../../../i18n/hooks/useLocaleInit';
import { mainTheme } from '../../../themes/mainTheme';

interface IAppBaseProps {
  children: JSX.Element;
}

export const muiCache = createCache({
  key: 'mui',
});

export function AppBase({ children }: IAppBaseProps): JSX.Element {
  useScrollToTop();

  const { isLocaleReady } = useLocaleInit();

  const { isInitialized } = useAuth();

  return (
    <CacheProvider value={muiCache}>
      <ThemeProvider theme={mainTheme}>
        <CssBaseline />
        {isLocaleReady && isInitialized ? children : <QueryLoadingAbsolute />}
        <Notifications />
      </ThemeProvider>
    </CacheProvider>
  );
}
